import { render, staticRenderFns } from "./OrticTextareaControl.vue?vue&type=template&id=295ee6f6"
import script from "./OrticTextareaControl.vue?vue&type=script&lang=js"
export * from "./OrticTextareaControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports